import { Component, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

export interface PeriodicElement {
  class: string;
  slno: number;
  fees: string;
}

export interface PeriodicElement1 {
  class: string;
  slno: number;
  criteria: string;
}
const ELEMENT_DATA: PeriodicElement[] = [
  {slno: 1, class: 'NURSERY - UKG', fees:'ADMISSION FEE -  ₹3400  TUTION FEE -  ₹2100  ANNUAL FEE - ₹4600   EXAM FEE - ₹0   ELECTRIC FEE - ₹400  '},
  {slno: 2, class: 'CLASS I & II', fees: 'ADMISSION FEE -  ₹3400   TUTION FEE - ₹2400   ANNUAL FEE - ₹4800   EXAM FEE - ₹1100   ELECTRIC FEE - ₹400  '},
  {slno: 3, class: 'CLASS III & IV', fees:'ADMISSION FEE -  ₹3400   TUTION FEE - ₹2500   ANNUAL FEE - ₹4800   EXAM FEE - ₹1200   ELECTRIC FEE - ₹400  '},
  {slno: 4, class: 'CLASS V', fees: 'ADMISSION FEE -  ₹3400   TUTION FEE - ₹2600   ANNUAL FEE - ₹4900   EXAM FEE - ₹1200   ELECTRIC FEE - ₹400  '},
  {slno: 5, class: 'CLASS VI', fees:'ADMISSION FEE -  ₹3400   TUTION FEE - ₹2100   ANNUAL FEE - ₹6000   EXAM FEE - ₹1500   ELECTRIC FEE - ₹400  '},
  {slno: 6, class: 'CLASS VII & VIII', fees: 'ADMISSION FEE - ₹4000   TUTION FEE - ₹2850   ANNUAL FEE - ₹6500   EXAM FEE - ₹2000   ELECTRIC FEE - ₹400'},
  {slno: 7, class: 'CLASS IX & X', fees: 'ADMISSION FEE - ₹4000   TUTION FEE - ₹3000   ANNUAL FEE - ₹7000   EXAM FEE - 3000   ELECTRIC FEE - ₹400'},
  {slno: 8, class: 'CLASS XI', fees:'ADMISSION FEE - ₹4000   TUTION FEE - ₹3300   ANNUAL FEE - ₹9500   EXAM FEE - ₹3000   ELECTRIC FEE - ₹400'},
  {slno: 9, class: 'CLASS XII', fees: 'ADMISSION FEE - ₹1600   TUTION FEE - ₹3500   ANNUAL FEE - ₹9500   EXAM FEE - ₹3000   ELECTRIC FEE - ₹400'},
];

const ELEMENT_DATA1: PeriodicElement1[] = [
  {slno: 1, class: 'PLAY GROUP', criteria:'MINIMUM 2 YEARS OF AGE'},
  {slno: 2, class: 'NURSERY', criteria: 'MINIMUM 3 YEARS OF AGE'},
  {slno: 3, class: 'JR. KG', criteria:'MINIMUM 4 YEARS OF AGE' },
  {slno: 4, class: 'SR. KG', criteria: 'MINIMUM 5 YEARS OF AGE'},
  {slno: 5, class: 'Grade 1', criteria: 'MINIMUM 6 YEARS OF AGE'},
  {slno: 6, class: 'Grade 2-12', criteria: 'AS APPROPRIATE'},
];
@Component({
  selector: 'app-academic',
  templateUrl: './academic.component.html',
  styleUrls: ['./academic.component.scss']
})
export class AcademicComponent {
  
  displayedColumns: string[] = ['slno', 'class', 'fees'];
  dataSource = ELEMENT_DATA;

  displayedColumns1: string[] = ['slno', 'class', 'criteria'];
  dataSource1 = ELEMENT_DATA1;
}
